import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';

// layout components

// theme provider
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import materialTheme from './utils/materialTheme';
import { esES } from '@mui/material/locale';

import NavBar from "./components/layout/NavBar";
import Landing from "./components/layout/Landing";

// auth components
// import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Dashboard from "./components/dashboard/Dashboard";

//inventory components
import IndexInventario from "./components/inventario/IndexInventario";
import AgregarProducto from "./components/inventario/AgregarProducto";
import TablaProductos from "./components/inventario/TablaProductos";
import EditarProducto from "./components/inventario/EditarProducto";
import TablaSalidas from "./components/salidas/TablaSalidas";
import SalidaProductos from "./components/salidas/SalidaProductos";
import ValeSalida from "./components/salidas/ValeSalida";
import Ingresos from "./components/inventario/Ingresos";
import Devoluciones from "./components/inventario/Devoluciones";
import TablaInventario from "./components/inventario/TablaInventario";
import DetalleMovimiento from "./components/inventario/DetalleMovimiento";
import SeguimientoProducto from "./components/inventario/SeguimientoProducto";
import AjusteInventario from "./components/inventario/AjusteInventario";

// pedidos components
import IndexPedidos from "./components/pedidos/IndexPedidos";
import AgregarPedido from "./components/pedidos/AgregarPedido";
import TablaPedidos from "./components/pedidos/TablaPedidos";
import EditarPedido from "./components/pedidos/EditarPedido";

// cotizaciones components
import TablaCotizaciones from "./components/cotizaciones/TablaCotizaciones";
import NuevaCotizacion from "./components/cotizaciones/NuevaCotizacion";
import EditarCotizacion from "./components/cotizaciones/EditarCotizacion";
import Cotizacion from "./components/cotizaciones/Cotizacion";
import CotizadorMembranas from "./components/cotizaciones/CotizadorMembranas";

// clientes components
import IndexClientes from "./components/clientes/IndexClientes";
import Clientes from "./components/clientes/Clientes";
import Proveedores from "./components/clientes/Proveedores";
import Hospitales from "./components/clientes/Hospitales";

// almacenes components
import IndexAlmacen from "./components/almacenes/IndexAlmacen";
import NuevoAlmacen from "./components/almacenes/NuevoAlmacen";
import Almacenes from "./components/almacenes/Almacenes";
import EditarAlmacen from "./components/almacenes/EditarAlmacen";

// stock components
import StockIndex from "./components/stock/StockIndex";

// images components
import ImageManager from "./components/images/ImageManager";

// informes components
import InformesIndex from "./components/informes/InformesIndex";
import ReporteVentas from "./components/informes/ReporteVentas";

// configuration components
import Config from "./components/config/Config";
import IndexConfig from "./components/config/IndexConfig";
import EditarPrecios from "./components/config/EditarPrecios";
import Categorias from "./components/config/Categorias";
import Usuarios from "./components/config/Usuarios";

// gastos components
import TablaGastos from "./components/gastos/TablaGastos";
import AgregarGasto from "./components/gastos/AgregarGasto";
import EditarGasto from "./components/gastos/EditarGasto";

// fcaturas components
import TablaFacturas from "./components/facturas/TablaFacturas";
import NuevaFactura from "./components/facturas/NuevaFactura";
import EditarFactura from "./components/facturas/EditarFactura";
import FormatoCotizacion from "./components/formatos/FormatoCotizacion";
import PrintFile from "./components/formatos/PrintFile";

// catalogos components
import IndexCatalogos from "./components/catalogos/IndexCatalogos";
import CatalogoTeclados from "./components/catalogos/CatalogoTeclados";
import CatalogoImpresion from "./components/catalogos/CatalogoImpresion";
import Seguimiento from "./components/cotizaciones/Seguimiento";
import Estadisticas from "./components/informes/Estadisticas";

const AppRoutes = () => {

    const colorMode = useSelector((state) => state.theme.colorMode);
    const [theme, setTheme] = useState(createTheme(materialTheme(localStorage.colorMode !== undefined ? localStorage.colorMode : 'light')));

    useEffect(() => {
        setTheme(createTheme(materialTheme(colorMode, esES)));
    }, [colorMode])

    return (
        <Router>
            <div className="App">
                <ThemeProvider theme={theme}>
                    <CssBaseline />

                    <NavBar colorMode={colorMode} />

                    <Routes>
                        <Route exact path="/" element={<Landing />} />
                        {/* <Route exact path="/register" component={Register} /> */}
                        <Route exact path="/login" element={<Login />} />

                        {/* <Route exact path="/admin" component={Admin} /> */}

                        {/* private routes with react-router-dom v6 */}
                        <Route exact path="/dashboard" element={<PrivateRoute />}>
                            <Route path="" element={<Dashboard />} />
                        </Route>

                        {/* Inventory routes */}
                        <Route exact path="/inventario" element={<PrivateRoute />}>
                            <Route path="" element={<IndexInventario />} />
                        </Route>
                        <Route exact path="/inventario/agregarProducto" element={<PrivateRoute />}>
                            <Route path="" element={<AgregarProducto />} />
                        </Route>
                        <Route exact path="/inventario/consultarProductos" element={<PrivateRoute />}>
                            <Route path="" element={<TablaProductos />} />
                        </Route>
                        <Route exact path="/inventario/editarProducto/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarProducto />} />
                        </Route>
                        <Route exact path="/inventario/salidas/" element={<PrivateRoute />}>
                            <Route path="" element={<TablaSalidas />} />
                        </Route>
                        <Route exact path="/inventario/salidaProductos/:id" element={<PrivateRoute />}>
                            <Route path="" element={<SalidaProductos />} />
                        </Route>
                        <Route exact path="/inventario/valeSalida/" element={<PrivateRoute />}>
                            <Route path="" element={<ValeSalida />} />
                        </Route>
                        <Route exact path="/inventario/ingresos/" element={<PrivateRoute />}>
                            <Route path="" element={<Ingresos />} />
                        </Route>
                        <Route exact path="/inventario/devoluciones/" element={<PrivateRoute />}>
                            <Route path="" element={<Devoluciones />} />
                        </Route>
                        <Route exact path="/inventario/tablaInventario/" element={<PrivateRoute />}>
                            <Route path="" element={<TablaInventario />} />
                        </Route>
                        <Route exact path="/inventario/DetalleMovimiento/:id" element={<PrivateRoute />}>
                            <Route path="" element={<DetalleMovimiento />} />
                        </Route>
                        <Route exact path="/inventario/seguimientoProducto/:id" element={<PrivateRoute />}>
                            <Route path="" element={<SeguimientoProducto />} />
                        </Route>
                        <Route exact path="/inventario/ajusteDeInventario" element={<PrivateRoute />}>
                            <Route path="" element={<AjusteInventario />} />
                        </Route>

                        {/* Batch routes */}
                        <Route exact path="/pedidos/" element={<PrivateRoute />}>
                            <Route path="" element={<IndexPedidos />} />
                        </Route>
                        <Route exact path="/pedidos/agregarPedido" element={<PrivateRoute />}>
                            <Route path="" element={<AgregarPedido />} />
                        </Route>
                        <Route exact path="/pedidos/verPedidos" element={<PrivateRoute />}>
                            <Route path="" element={<TablaPedidos />} />
                        </Route>
                        <Route exact path="/pedidos/editarPedido/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarPedido />} />
                        </Route>

                        {/* Order routes */}
                        <Route exact path="/cotizaciones/" element={<PrivateRoute />}>
                            <Route path="" element={<TablaCotizaciones />} />
                        </Route>
                        <Route exact path="/cotizaciones/nueva" element={<PrivateRoute />}>
                            <Route path="" element={<NuevaCotizacion />} />
                        </Route>
                        <Route exact path="/cotizaciones/editar/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarCotizacion />} />
                        </Route>
                        <Route exact path="/cotizaciones/cotizacion/:id" element={<PrivateRoute />}>
                            <Route path="" element={<Cotizacion />} />
                        </Route>
                        <Route exact path="/cotizacionMembrana/" element={<PrivateRoute />}>
                            <Route path="" element={<CotizadorMembranas />} />
                        </Route>
                        <Route exact path="/cotizaciones/seguimiento" element={<PrivateRoute />}>
                            <Route path="" element={<Seguimiento />} />
                        </Route>

                        {/* clients routes */}
                        <Route exact path="/clientes/" element={<PrivateRoute />}>
                            <Route path="" element={<IndexClientes />} />
                        </Route>
                        <Route exact path="/clientes/consultarClientes" element={<PrivateRoute />}>
                            <Route path="" element={<Clientes />} />
                        </Route>
                        <Route exact path="/clientes/consultarProveedores" element={<PrivateRoute />}>
                            <Route path="" element={<Proveedores />} />
                        </Route>
                        <Route exact path="/clientes/consultarHospitales" element={<PrivateRoute />}>
                            <Route path="" element={<Hospitales />} />
                        </Route>

                        {/* warehouses routes */}
                        <Route exact path="/almacenes/" element={<PrivateRoute />}>
                            <Route path="" element={<IndexAlmacen />} />
                        </Route>
                        <Route exact path="/almacenes/verAlmacenes" element={<PrivateRoute />}>
                            <Route path="" element={<Almacenes />} />
                        </Route>
                        <Route exact path="/almacenes/nuevoAlmacen" element={<PrivateRoute />}>
                            <Route path="" element={<NuevoAlmacen />} />
                        </Route>
                        <Route exact path="/almacenes/editarAlmacen/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarAlmacen />} />
                        </Route>

                        {/* imagenes routes */}
                        <Route exact path="/imagenes/" element={<PrivateRoute />}>
                            <Route path="" element={<ImageManager />} />
                        </Route>

                        {/* stock routes */}
                        <Route exact path="/stock" element={<PrivateRoute />}>
                            <Route path="" element={<StockIndex />} />
                        </Route>

                        {/* infomres routes */}
                        <Route exact path="/informes" element={<PrivateRoute />}>
                            <Route path="" element={<InformesIndex />} />
                        </Route>
                        <Route exact path="/informes/reporteVentas" element={<PrivateRoute />}>
                            <Route path="" element={<ReporteVentas />} />
                        </Route>
                        <Route exact path="/informes/estadisticasGenerales" element={<PrivateRoute />}>
                            <Route path="" element={<Estadisticas />} />
                        </Route>

                        {/* configuration routes */}
                        <Route exact path="/config" element={<PrivateRoute />}>
                            <Route path="" element={<IndexConfig />} />
                        </Route>
                        <Route exact path="/config/precios" element={<PrivateRoute />}>
                            <Route path="" element={<EditarPrecios />} />
                        </Route>
                        <Route exact path="/config/categorias" element={<PrivateRoute />}>
                            <Route path="" element={<Categorias />} />
                        </Route>
                        <Route exact path="/config/usuarios" element={<PrivateRoute />}>
                            <Route path="" element={<Usuarios />} />
                        </Route>

                        {/* gastos routes */}
                        <Route exact path="/gastos" element={<PrivateRoute />}>
                            <Route path="" element={<TablaGastos />} />
                        </Route>
                        <Route exact path="/gastos/agregarGasto" element={<PrivateRoute />}>
                            <Route path="" element={<AgregarGasto />} />
                        </Route>
                        <Route exact path="/gastos/editarGasto/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarGasto />} />
                        </Route>

                        {/* facturas routes */}
                        <Route exact path="/facturas" element={<PrivateRoute />}>
                            <Route path="" element={<TablaFacturas />} />
                        </Route>
                        <Route exact path="/facturas/nuevaFactura" element={<PrivateRoute />}>
                            <Route path="" element={<NuevaFactura />} />
                        </Route>
                        <Route exact path="/facturas/editarFactura/:id" element={<PrivateRoute />}>
                            <Route path="" element={<EditarFactura />} />
                        </Route>

                        {/* print routes */}
                        <Route exact path="/print/" element={<PrivateRoute />}>
                            <Route path="" element={<PrintFile />} />
                        </Route>

                        {/* catalogos routes */}
                        <Route exact path="/catalogos" element={<PrivateRoute />}>
                            <Route path="" element={<IndexCatalogos />} />
                        </Route>
                        <Route exact path="/catalogos/teclados" element={<PrivateRoute />}>
                            <Route path="" element={<CatalogoTeclados />} />
                        </Route>
                        <Route exact path="/catalogos/impresion3d" element={<PrivateRoute />}>
                            <Route path="" element={<CatalogoImpresion />} />
                        </Route>

                    </Routes>
                </ThemeProvider>
            </div>
        </Router>
    )
}

export default AppRoutes;